import { IFilterItem } from "../../models/filter-item-model";
import { IDictionary } from "@/shared/models/interface/dictionary-model";
import { BaseFilterQueryService } from "../base-filter-query-service";

export class VUFilterQueryService extends BaseFilterQueryService {
    public addUserFilter(filters: IDictionary<IFilterItem[]>): BaseFilterQueryService {
        Object.keys(filters)?.forEach((filterGroup: string) => {
            let explicitFilters = filters[filterGroup]
                ?.filter(x => x.IsExplicit)
                ?.map(x => x.FilterCodeName);
            let implicitFilters = filters[filterGroup]
                ?.filter(x => x.IsImplicit)
                ?.map(x => x.FilterCodeName);

            let explicitQuery = this.getListSyntax('Filter', explicitFilters);
            let implicitQuery = this.getListSyntax('ImplicitFilter', implicitFilters);

            let query = [explicitQuery, implicitQuery].join(' or ');

            this.appendFilter(`(${query})`);
        });

        return this;
    }

}
